export enum PrintTypeEnum {
  LABEL = 1,
  WAYBILL = 2,
  RECEIPT = 4,
  PICKING_LIST = 8
}

export enum PrintFormatEnum {
  PDF = 'pdf',
  ZPL = 'zpl',
}

export enum PrintSettingsEnum {
  REGULAR = 'regular',
  A4_3_HORIZONTAL = 'a4_3_horizontal',
  TOP_STICKER = 'top_sticker',
  LABEL = 'label'
}





// WEBPACK FOOTER //
// ./src/app/model/print.enum.ts